import { Alert, AlertTitle, Box, Button, Dialog, DialogContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import React, { useState } from "react";

interface SecondaryAsPrimaryDialogProps {
  open: boolean;
  onClose: () => void;
  pendingData: any;
}

export const SecondaryAsPrimaryDialog: React.FC<SecondaryAsPrimaryDialogProps> = ({
  open,
  onClose,
  pendingData,
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmSetAsPrimary = async () => {
    if (pendingData) {
      setLoading(true);
      try {
        await pendingData.submitFunction();
      } catch (error) {
        console.error(error);
      } finally {
        onClose();
        setLoading(false);
      }
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={handleCancel}
      aria-labelledby="new-authorization-title"
    >
      <DialogContent sx={{ zIndex: 2010 }}>
        <Alert severity="warning" sx={{ marginBottom: "24px" }}>
          <AlertTitle>Set the secondary insurance as primary?</AlertTitle>
          This will additionally set the primary insurance as inactive and move it into past
          coverage.
        </Alert>

        <Box width="100%" display="flex" flexDirection="row" justifyContent="flex-end">
          <Button
            onClick={handleCancel}
            style={{ marginRight: "8px" }}
            variant="contained"
            color="secondary"
            disabled={loading}
          >
            Cancel
          </Button>
          <LoadingButton onClick={handleConfirmSetAsPrimary} loading={loading}>
            Set as Primary Insurance
          </LoadingButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
